import { Dispatch } from 'redux'

import {
  actionTypes,
  fetchVendorsError,
  VendorsFetchAction,
  fetchVendorsSuccess,
  LocationsFetchAction,
  EntityDeleteFileAction,
  EntityDownloadFileAction,
  fetchLocationPositionsError,
  LocationsFetchSuccessAction,
  LocationPositionsFetchAction,
  fetchLocationPositionsSuccess,
  fetchLocationsErrorDispatchCommand,
  fetchLocationsSuccessDispatchCommand
} from './actions'

import { deleteEntityFile, downloadEntityFile } from 'src/lib/api/files'
import { getVendors, getLocations, getLocationPositions } from 'src/lib/api/locations'

import { accidentFilterParamsResetDispatchCommand } from '../accidents/actions'

import { RootState } from '../rootReducer'

import { Vendor } from 'src/lib/interfaces/Vendor.interface'
import { hasPermission } from 'src/lib/interfaces/User.interface'
import { AccidentFilterParameters } from  'src/lib/interfaces/AccidentFilterParameters.interface'

import { getPureFileKey } from '../../utils/files'

const { createLogic } = require('redux-logic')

const get = require('lodash/get')
const map = require('lodash/map')
const last = require('lodash/last')

type OnDoneType = () => void

const onFetchLocationsLogic = createLogic({
  type: actionTypes.LOCATIONS_FETCH,
  process({ action, getState }: { action: LocationsFetchAction, getState: () => RootState }, dispatch: Dispatch, done: OnDoneType) {
    getLocations()
      .then((locations: Location[]) =>
        dispatch(fetchLocationsSuccessDispatchCommand(locations))
      )
      .catch((err) => dispatch(fetchLocationsErrorDispatchCommand(err)))
      .then(() => done())
  }
})

const onFetchLocationsSuccessLogic = createLogic({
  type: actionTypes.LOCATIONS_FETCH_SUCCESS,
  process({ action, getState }: { action: LocationsFetchSuccessAction, getState: () => RootState }, dispatch: Dispatch, done: OnDoneType) {
    const locations = action.payload.locations

    const state = getState()
    const user = state.auth.user
    if (user && !hasPermission(user, 'ROLE_ACCIDENT_ADMIN')) {
      const currentFilterParamsLocations = get(state, 'accidents.filterParams.location')
      if (!currentFilterParamsLocations) {
        const filterParams: AccidentFilterParameters = {
          location: map(locations, location => location.id)
        }

        dispatch(accidentFilterParamsResetDispatchCommand(filterParams))
      }
    }

    done()
  }
})

const onFetchLocationPositionsLogic = createLogic({
  type: actionTypes.LOCATION_POSITIONS_FETCH,
  process({ action }: { action: LocationPositionsFetchAction }, dispatch: Dispatch, done: OnDoneType) {
    const locationId = action.payload.locationId

    getLocationPositions(locationId)
      .then((positions: Position[]) => dispatch(fetchLocationPositionsSuccess(locationId, positions)))
      .catch(err => dispatch(fetchLocationPositionsError(err.message)))
      .then(done)
  }
})

const onFetchVendorsLogic = createLogic({
  type: actionTypes.VENDORS_FETCH,
  process({ action }: { action: VendorsFetchAction }, dispatch: Dispatch, done: OnDoneType) {
    getVendors()
      .then((vendors: Vendor[]) => dispatch(fetchVendorsSuccess(vendors)))
      .catch(err => dispatch(fetchVendorsError(err)))
      .then(done)
  }
})

const onDownloadEntityFileLogic = createLogic({
  type: actionTypes.ENTITY_DOWNLOAD_FILE,
  process({ action }: { action: EntityDownloadFileAction }, dispatch: Dispatch, done: OnDoneType) {
    const { entity, entityId, fileKey, next } = action.payload

    const pureFileKey = getPureFileKey(fileKey)
    downloadEntityFile(entity, entityId, pureFileKey)
      .then((file: string) => next(null, file))
      .catch((err: any) => next(err))
      .then(done)
  }
})

const onDeleteEntityFileLogic = createLogic({
  type: actionTypes.ENTITY_DELETE_FILE,
  process({ action }: { action: EntityDeleteFileAction }, dispatch: Dispatch, done: OnDoneType) {
    const { entity, entityId, fileKey, next } = action.payload

    const pureFileKey = getPureFileKey(fileKey)
    deleteEntityFile(entity, entityId, pureFileKey)
      .then(() => next && next())
      .catch((err: any) => next && next(err))
      .then(done)
  }
})

export const appLogicList = [
  onFetchLocationsLogic,
  onFetchLocationsSuccessLogic,
  onFetchLocationPositionsLogic,
  onFetchVendorsLogic,
  onDownloadEntityFileLogic,
  onDeleteEntityFileLogic
]



// WEBPACK FOOTER //
// ./src/store/app/logic.ts